// @flow

export function isValidPassword(password: string): boolean {
  return password.length >= 8;
}
